import React from 'react';
import { View } from 'react-native';
import BreakdownItem from './BreakdownItem';
import { ScaledSheet } from '@utils/scale';

interface TransactionItem {
  title: string;
  key: string;
  nav_to?: string;
  value: number;
  value_txt: string;
  is_expandable: boolean;
  value_color: string;
  extra_info?: Array<{ title: string; value: string }>;
  buttons?: Array<{ title: string; nav_to: string }>;
}

interface BreakdownListProps {
  data?: TransactionItem[];
  date?: string;
  date_range?: string;
}

/**
 * BreakdownList Component
 * Displays list of earnings breakdown items
 */
const BreakdownList: React.FC<BreakdownListProps> = ({ data, date, date_range }) => {
  if (!data || data.length === 0) {
    return null;
  }

  return (
    <View style={styles.container}>
      {data.map((item, index) => (
        <BreakdownItem
          key={`${item.key}-${index}`}
          date={date}
          date_range={date_range}
          label={item.title}
          amount={item.value_txt}
          is_expandable={item.is_expandable}
          extra_info={item.extra_info}
          buttons={item.buttons}
          onPress={() => {}}
        />
      ))}
    </View>
  );
};

const styles = ScaledSheet.create({
  container: {
    paddingHorizontal: 12,
    marginBottom: 12,
    gap: 12,
  },
});

export default BreakdownList;
